export class BaseWebComponentDataProvider {
  public dependenciesInjected: boolean;
  public dependencies: any;

  initialSetup() {
    this.dependenciesInjected = false;
    this.dependencies = {};
  }

  injectDependencies(dependencies: any) {
    this.dependencies = dependencies;
    this.build();
    this.dependenciesInjected = true;
  }

  build() {
    // to be implemented
  }
}
